import { transparentize } from "polished";
export const colors = {
  text: {
    dark: "#ffffff",
    light: "#000000",
    semantic: "#000000"
  },
  clip: {
    dark: "#694AD6",
    light: "#FFFFFF",
    semantic: "#FFFFFF"
  },
  default: {
    dark: "#8271C8",
    light: "#8DB9E2",
    semantic: "#84b1de"
  },
  primary: {
    dark: "#4ABEFF",
    light: "#037cdf",
    semantic: "#4183c4"
  },
  divider: {
    dark: "#28268A",
    light: "#CDE1F1",
    semantic: "#d0dee5"
  },
  warning: {
    dark: "#ff9d00",
    light: "#ff9d00",
    semantic: "#fbbd08"
  },
  positive: {
    dark: "#67FFD1",
    light: "#36c55f",
    semantic: "#21ba45"
  },
  negative: {
    dark: "#FF6B8F",
    light: "#ee5555",
    semantic: "#db2828"
  },
  selected: {
    dark: "#BBCAFF",
    light: "#037cdf",
    semantic: "#4183c4"
  },
  secondary: {
    dark: "#C6E0F8",
    light: "#88BEEF",
    semantic: "#c9deea"
  },
  transparent: {
    dark: "transparent",
    light: "transparent",
    semantic: "transparent"
  }
};
export const transparentized = Object.keys(colors).reduce((map, color) => {
  map[color] = Object.keys(colors[color]).reduce((map, theme) => {
    map[theme] = transparentize(0.76, colors[color][theme]);
    return map;
  }, {});
  return map;
}, {});
export default colors;
//# sourceMappingURL=colors.js.map